import React from 'react';
import {Glyphicon} from 'react-bootstrap';

const iconsSVG = require('../../constants/iconsSVG.js');
const iconTypes = require('../../constants/iconTypes.js');

export default class CustomToolTip extends React.Component {
  constructor(props){
    super(props);
  }

  getSVG(icon){
    let render_svg;
    let style = {
      width:'20px',
      height:'20px'
    };
    if(this.props.iconOnly) {
      style = {
        height: '30px',
        width: '30px',
        fontSize: '30px',
        boxShadow: '2px 2px 5px #c3c3c3',
        borderRadius: '50%',
      }
    }
    if(this.props.largeIcon){
      style = {
        fontSize: '34px',
      }
    }
    switch(icon){
      case iconTypes.ASTERISK:
        return (<Glyphicon style={style} glyph="asterisk" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.BULLHORN:
        return (<Glyphicon style={style} glyph="bullhorn" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.CALENDAR:
        return (<Glyphicon style={style} glyph="calendar" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.COMMENT:
        return (<Glyphicon style={style} glyph="comment" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.CERTIFICATE:
        return (<Glyphicon style={style} glyph="certificate" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.CLOUD:
        return (<Glyphicon style={style} glyph="cloud" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.COG:
        return (<Glyphicon style={style} glyph="cog" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.DASHBOARD:
        return (<Glyphicon style={style} glyph="dashboard" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.DOWNLOAD:
        return (<Glyphicon style={style} glyph="download" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.DOWNLOAD_ALT:
        return (<Glyphicon style={style} glyph="download-alt" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.CLOUD_DOWNLOAD:
        return (<Glyphicon style={style} glyph="cloud-download" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.EYE_OPEN:
        return (<Glyphicon style={style} glyph="eye-open" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.FILE:
        return (<Glyphicon style={style} glyph="file" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.FIRE:
        return (<Glyphicon style={style} glyph="fire" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.FILTER:
        return (<Glyphicon style={style} glyph="filter" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.FLASH:
        return (<Glyphicon style={style} glyph="flash" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.FLAG:
        return (<Glyphicon style={style} glyph="flag" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.FOLDER_CLOSE:
        return (<Glyphicon style={style} glyph="folder-close" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.FOLDER_OPEN:
        return (<Glyphicon style={style} glyph="folder-open" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.HAND_UP:
        return (<Glyphicon style={style} glyph="hand-up" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.HAND_DOWN:
        return (<Glyphicon style={style} glyph="hand-down" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.HAND_LEFT:
        return (<Glyphicon style={style} glyph="hand-left" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.HAND_RIGHT:
        return (<Glyphicon style={style} glyph="hand-right" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.HOURGLASS:
        return (<Glyphicon style={style} glyph="hourglass" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.INBOX:
        return (<Glyphicon style={style} glyph="inbox" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.LIST_ALT:
        return (<Glyphicon style={style} glyph="list-alt" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.LOCK:
        return (<Glyphicon style={style} glyph="lock" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.MINUS:
        return (<Glyphicon style={style} glyph="minus" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.MENU:
        return (<Glyphicon style={style} glyph="menu" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.MENU_LEFT:
        return (<Glyphicon style={style} glyph="menu-left" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.MENU_RIGHT:
        return (<Glyphicon style={style} glyph="menu-right" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.MENU_DOWN:
        return (<Glyphicon style={style} glyph="menu-down" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.MENU_UP:
        return (<Glyphicon style={style} glyph="menu-up" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.OK:
        return (<Glyphicon style={style} glyph="ok" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.PUSHPIN:
        return (<Glyphicon style={style} glyph="pushpin" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.REFRESH:
        return (<Glyphicon style={style} glyph="refresh" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.RANDOM:
        return (<Glyphicon style={style} glyph="random" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.SAVE:
        return (<Glyphicon style={style} glyph="save" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.SCALE:
        return (<Glyphicon style={style} glyph="scale" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.STAR:
        return (<Glyphicon style={style} glyph="star" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.STAR_EMPTY:
        return (<Glyphicon style={style} glyph="star-empty" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.SEARCH:
        return (<Glyphicon style={style} glyph="search" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.TIME:
        return (<Glyphicon style={style} glyph="time" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.TRASH:
        return (<Glyphicon style={style} glyph="trash" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.THUMBS_UP:
        return (<Glyphicon style={style} glyph="thumbs-up" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.THUMBS_DOWN:
        return (<Glyphicon style={style} glyph="thumbs-down" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.TAGS:
        return (<Glyphicon style={style} glyph="tags" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.TASKS:
        return (<Glyphicon style={style} glyph="tasks" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.USER:
        return (<Glyphicon style={style} glyph="user" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.WARNING_SIGN:
        return (<Glyphicon style={style} glyph="warning-sign" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.ZOOM_IN:
        return (<Glyphicon style={style} glyph="zoom-in" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.ZOOM_OUT:
        return (<Glyphicon style={style} glyph="zoom-out" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.ADD:
        return (<Glyphicon style={style} glyph="plus" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.ALERT:
        return (<Glyphicon style={style} glyph="alert" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.APPARATUS:
        render_svg = iconsSVG.APPARATUS;
        break;
      case iconTypes.APPROVE:
        render_svg = iconsSVG.APPROVE;
        break;
      case iconTypes.BID:
        render_svg = iconsSVG.BID;
        break;
      case iconTypes.CALLOUT:
        render_svg = iconsSVG.CALLOUT;
        break;
      case iconTypes.CANCEL:
        render_svg = iconsSVG.CANCEL;
        break;
      case iconTypes.CLOCKIN:
        render_svg = iconsSVG.CLOCKIN;
        break;
      case iconTypes.CLOCKOUT:
        render_svg = iconsSVG.CLOCKOUT;
        break;
      case iconTypes.CREATE:
        render_svg = iconsSVG.CREATE;
        break;
      case iconTypes.CROSSSTATION:
        render_svg = iconsSVG.CROSSSTATION;
        break;
      case iconTypes.DELETE:
        render_svg = iconsSVG.DELETE;
        break;
      case iconTypes.DAY:
        render_svg = iconsSVG.DAY;
        break;
      case iconTypes.DENY:
        render_svg = iconsSVG.DENY;
        break;
      case iconTypes.EDIT:
        return (<Glyphicon style={style} glyph="pencil" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.ENVELOPE:
        return (<Glyphicon style={style} glyph="envelope" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.EVENT:
        render_svg = iconsSVG.EVENT;
        break;
      case iconTypes.EXCHANGE:
        render_svg = iconsSVG.EXCHANGE;
        break;
      case iconTypes.FULL:
        render_svg = iconsSVG.FULL;
        break;
      case iconTypes.HELP:
        return (<Glyphicon style={style} glyph="question-sign" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.INFO:
        return (<Glyphicon style={style} glyph="info-sign" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.MONTH:
        render_svg = iconsSVG.MONTH;
        break;
      case iconTypes.OFFER:
        render_svg = iconsSVG.OFFER;
        break;
      case iconTypes.OFFER2:
        render_svg = iconsSVG.OFFER2;
        break;
      case iconTypes.ONDUTY:
        render_svg = iconsSVG.ONDUTY;
        break;
      case iconTypes.ONDUTYPOLICE:
        render_svg = iconsSVG.ONDUTYPOLICE;
        break;
      case iconTypes.ONSHIFT_BADGE:
        render_svg = iconsSVG.ONSHIFT_BADGE;
        break;
      case iconTypes.OVERTIME:
        render_svg = iconsSVG.OVERTIME;
        break;
      case iconTypes.PARTIAL:
        render_svg = iconsSVG.PARTIAL;
        break;
      case iconTypes.PAYPERIOD:
        render_svg = iconsSVG.PAYPERIOD;
        break;
      case iconTypes.PLUS:
        return (<Glyphicon style={style} glyph="plus" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.PTO:
        render_svg = iconsSVG.PTO;
        break;
      case iconTypes.REPORTS:
        render_svg = iconsSVG.REPORTS;
        break;
      case iconTypes.STATION:
        render_svg = iconsSVG.STATION;
        break;
      case iconTypes.SETUP:
        return (<Glyphicon style={style} glyph="wrench" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.SCHEDULED_DUTY:
        render_svg = iconsSVG.SCHEDULED_DUTY;
        break;
      case iconTypes.SHIFT:
        render_svg = iconsSVG.SHIFT;
        break;
      case iconTypes.SHIFTBOARD:
        return (<Glyphicon style={style} glyph="transfer" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.SIGNUP:
        render_svg = iconsSVG.SIGNUP;
        break;
      case iconTypes.SIGNUP_EVENT:
        render_svg = iconsSVG.SIGNUP_EVENT;
        break;
      case iconTypes.SUB:
        render_svg = iconsSVG.SUB;
        break;
      case iconTypes.TIME_CHANGE:
        render_svg = iconsSVG.TIME_CHANGE;
        break;
      case iconTypes.TIMECLOCK_RECORD:
        render_svg = iconsSVG.TIMECLOCK_RECORD;
        break;
      case iconTypes.TIMEOFF:
        render_svg = iconsSVG.TIMEOFF;
        break;
      case iconTypes.VIEW:
        return (<Glyphicon style={style} glyph="eye-open" className={this.props.className + " " + this.props.iconClass} />);
      case iconTypes.WEEK:
        render_svg = iconsSVG.WEEK;
        break;
      default:
        render_svg = null;
        break;
    }

    if(render_svg === null) return null;

    if(this.props.largeIcon){
      return (
        <img className={"svg-img "+ this.props.iconClass} src={render_svg} alt={icon} style={{width: '34px', height: '34px'}}/>
      );
    }
    return (
      <img className={"svg-img "+ this.props.iconClass} src={render_svg} alt={icon}/>
    );
  }

  render() {
    const customClass = this.props.largeIcon ? "" : "customToolTip ";
    const svgIcon = this.getSVG(this.props.icon);
    if(!this.props.icon || svgIcon === null) {
      return null;
    }
    return (
      <div className={customClass + this.props.extraClass} style={this.props.iconOnly ? {width: '30px', maxWidth: '40px'} : {}}>
        <abbr title={this.props.text}>
          {svgIcon}
        </abbr>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/CustomToolTip.js